module.exports = __webpack_public_path__ + "static/img/Jamal-Shibasaki.c1606c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jamal-Shibasaki.jpg
// module id = VCzG
// module chunks = 0